import React from 'react'
import { useTranslation } from 'react-i18next'
import { StandardCard } from '../../../../components/shared/standardCard/standardCard'
import { Box, Tooltip, Typography } from '@material-ui/core'
import { Info } from '@material-ui/icons'
import { StandardCardTooltip } from '../../../../components/shared/standardCard/standardCardToolTip/standardCardToolTip'

interface UsesCardProps {
  showPercentageError?: boolean
  hasOneUse?: boolean
}

export const UsesCard: React.FC<UsesCardProps> = ({ showPercentageError, hasOneUse, children }) => {
  const [t] = useTranslation(['globalerisLibrary', 'uses'])

  return (
    <>
      <StandardCard title={t('uses:components.usesCard.title')}>{children}</StandardCard>
      {showPercentageError && hasOneUse && (
        <StandardCardTooltip
          tooltipTitle={t('uses:components.usesCard.tooltip.percentageError.icon')}
          tooltipCaption={t('uses:components.usesCard.tooltip.percentageError.caption')}
          error={showPercentageError}
        />
      )}
      {/* {!hasOneUse && (
        <StandardCardTooltip
          tooltipTitle={t('uses:components.usesCard.tooltip.hasOneUse.icon')}
          tooltipCaption={t('uses:components.usesCard.tooltip.hasOneUse.caption')}
          error={!hasOneUse}
        />
      )} */}
    </>
  )
}
